import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet } from "../../api/apiclient";
import { PROFILE_API } from "../../api/endpoints";

// Async thunk for logging in
export const getProfile = createAsyncThunk(
  "profile/",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiGet(PROFILE_API);
      console.log('profilr===>',response?.data)
      if (response?.data.status === "success") {
        return response?.data;
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);

const ProfileSlice = createSlice({
    name: "profile",
    initialState: {
      profileDetailsLoading: false,
      profileDetailsError: {},
      profileDetails: {}
    },
    extraReducers: (builder) => {
      builder
        .addCase(getProfile.pending, (state) => {
          state.profileDetailsLoading = true;
          state.error = null;
        })
        .addCase(getProfile.fulfilled, (state, action) => {
          state.profileDetailsLoading = false;
          state.profileDetails = action.payload?.data
        })
        .addCase(getProfile.rejected, (state, action) => {
          state.profileDetailsLoading = false;
          state.profileDetailsError = action.payload;
        });
    },
  });
  
  export default ProfileSlice.reducer;
  